module.exports = __webpack_public_path__ + "static/img/goldentoad_en.e05f4bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/goldentoad_en.png
// module id = TwqH
// module chunks = 1